import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NbDialogService } from '@nebular/theme';
import { SelectMediaModalComponent } from './library/select-media-modal.component';

import { MediaService } from '../../_services/index';
import { Media } from '../../classes';

import { Storage, ref, uploadString, percentage, uploadBytesResumable, UploadTask } from '@angular/fire/storage';

import { environment } from '../../../environments/environment';

/**
 * @fileOverview
 * Media library component
 * Manage templates/games medias (pictures/videos)
 * Medias are stored at template/game level
 * Medias used in game missions can be selected from media lib to avoid file doublons
 *
 * @author Stephane Draux <stephane.draux@gmail.com>
 */

@Component({
    selector: 'app-media-selector',
    templateUrl: './media-selector.component.html',
    styleUrls: ['./media-selector.component.scss'],
    standalone: false
})

export class MediaSelectorComponent {

  @Input() type; //image/video/audio
  @Input() fileURL;
  @Input() gameId;
  @Input() templateId;

  @Output() mediaUpdated = new EventEmitter();
  @Output() delete = new EventEmitter();

  selectedFile;
  task;
  progress;

  constructor(private route: ActivatedRoute,
    public mediaService: MediaService,
    private storage: Storage,
    private dialogService: NbDialogService) {
  }

  ngOnInit() {
  }

  pickGallery(){
    this.dialogService.open(SelectMediaModalComponent, { 
      context: {
        gameId: this.gameId,
        templateId: this.templateId
      }, closeOnBackdropClick: false
    })
    .onClose.subscribe(res => {
      console.log('Dialog returns:'+res);
      this.mediaUpdated.emit(res);
    });
  }

  async handleFileUpdated(file){
    console.log('Selected file:'+file);
    this.selectedFile = file;
    await this.saveMedia();
  }

  async saveMedia(){
    
    const filePath = this.getStoragePath();
    let mediaId = this.mediaService.createMediaRef(filePath).id;
    
    let fileName = `/${mediaId}`;

    let uploadRef = ref(this.storage, filePath+fileName);
    //let task:any = uploadString(uploadRef, this.selectedFile, 'data_url');
    let blob = await (await fetch(this.selectedFile)).blob();
    console.log('Blob:'+blob);
    let task:any = uploadBytesResumable(uploadRef, blob);

    task.then(async () => {
      const url = 'https://storage.googleapis.com/'+environment.firebase.storageBucket+'/'+filePath+fileName;
      console.log('file uploaded to:'+url);
      let res = await this.createMedia(mediaId, url, filePath+fileName);
      console.log('createMedia res:'+res);
      if(res){
        this.mediaUpdated.emit({fileURL:url, filePath:filePath+fileName, lastUpdate:new Date().getTime()});
      }
      setTimeout(() => {
        delete this.progress;
      }, 1000);
    });

    // Percentage observer
    percentage(task).subscribe((percentage) => {
      this.progress =  Math.round(percentage.progress);
    });
  }

  getStoragePath(){
    if(this.gameId){
      return `games/${this.gameId}/medias`;
    }
    else{
      return `game_templates/${this.templateId}/medias`;
    }
  }

  async createMedia(id, fileURL, filePath){
    let media = new Media(this.getStoragePath());
    media.id = id;
    if(this.templateId){
      media.templateId = this.templateId;
    }
    if(this.gameId){
      media.gameId = this.gameId;
    }
    //media.name = this._model.labels['en']+'_picture';
    media.type = this.type || '';
    media.fileURL = fileURL;
    media.filePath = filePath;
    media.lastUpdate = new Date().getTime();
    console.log('media to add:'+JSON.stringify(media));
    await this.mediaService.setMedia(media);
    console.log('added media:'+media.id);
    return media.id;
  }
}